module.exports = __webpack_public_path__ + "static/img/hyzc-01.a147121.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/hyzc-01.svg
// module id = Yhrh
// module chunks = 1